<div class="cr-status-wrap">
  <!-- Single -- section -->
  <span *ngIf="showPlain; else contentTpl" class="cr-plain"> -- </span>

  <ng-template #contentTpl>
    <span
      *ngIf="showStatus"
      class="cr-badge"
      [ngStyle]="{
        background: cfg.bg,
        color: cfg.text,
      }"
    >
      {{ cfg.label }}
    </span>

    <span *ngIf="shouldShowDelta" class="cr-delta" [style.color]="deltaColor">
      {{ formattedDelta }}
    </span>
  </ng-template>
</div>
